import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";

export const AudioClueButton = (props) => {
  const {
    clueObj,
    loadedClue,
    handleLoadClueClick,
    puzzlesDone,
    selectedPuzzleObj,
    color,
    isSent,
    userPermissions,
  } = props;
  const [showControls, setShowControls] = useState();

  const includesId = selectedPuzzleObj ? selectedPuzzleObj.id : 0;

  const style = () => {
    if (isSent) {
      if (loadedClue.id === clueObj.id) {
        return {
          background: "rgb(23, 24, 28)",
          border: "2px solid #0168fa",
          opacity: "0.7",
        };
      } else {
        return {
          border: "2px solid transparent",
          opacity: "0.7",
        };
      }
    } else if (loadedClue.id === clueObj.id) {
      return {
        background: "rgb(23, 24, 28)",
        border: "2px solid #0168fa",
      };
    } else {
      return {
        border: "2px solid transparent",
      };
    }
  };

  const clueObject = {
    ...clueObj,
    color,
  };

  const clueRating = () => {
    if (clueObj.rating) {
      if (clueObj.rating === 1) {
        return (
          <div className="clue-rating-box">
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
          </div>
        );
      } else if (clueObj.rating === 2) {
        return (
          <div className="clue-rating-box">
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
          </div>
        );
      } else if (clueObj.rating === 3) {
        return (
          <div className="clue-rating-box">
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
          </div>
        );
      } else if (clueObj.rating === 4) {
        return (
          <div className="clue-rating-box">
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
          </div>
        );
      } else if (clueObj.rating === 5) {
        return (
          <div className="clue-rating-box">
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
            <i
              className="icon ion-md-star"
              style={{ color: "rgb(236, 236, 88)" }}
            ></i>
          </div>
        );
      }
    }
  };

  return (

<button
      className="media"
      onClick={() => handleLoadClueClick(clueObject)}
      onMouseOver={() =>
        setShowControls(
          userPermissions.isAdmin || userPermissions.canEditHints ? true : false
        )
      }
      onMouseLeave={() => setShowControls(false)}
      style={{...style() }}
    >



      {isSent ? (
        <div>
          <Tooltip title="Sent" placement="top">
            <i className="icon ion-md-send tx-16"></i>
          </Tooltip>
        </div>
      ) : (
        <div>
          <Tooltip title="Audio Hint" placement="top">
            <i
              className="icon ion-md-volume-high tx-16"
              style={{ color: "rgb(114 124 128)", marginTop: "-2px" }}
            ></i>
          </Tooltip>
        </div>
      )}



      <div className="media-body mg-l-10" style={{alignItems: "center"}}>

      {/* <small className="d-block text-muted" style={{fontSize:'12px', marginBottom:'3px'}}>
            <i
              className="icon ion-md-return-right"
              style={{ color: "rgb(114 124 128)", marginTop: "-2px", marginLeft:'5px', marginRight:'5px', transform: 'rotateX(180deg)', display:'inline-flex' }}
            ></i>
            On Puzzle Complete
        </small> */}


        <h6
          className="mg-b-0"
          style={{
            fontStyle: isSent ? "italic" : "inherit",
          }}
        >
          {clueObj.message}
        </h6>

        <small className="d-block text-muted">
          {/* {clueObj.puzzle} */}
          {clueObj.rating ? clueRating() : null}
          <span>clue_hint.mp3 - 00:05</span>
        </small>

        {showControls ? (
          <Tooltip title="Edit" placement="right">
            <i
              className="icon ion-ios-more"
              // style={{fontSize:'18px', height:'16px', float:'right'}}
              style={{
                fontSize: "18px",
                position: "absolute",
                right: "20px",
                transform: "translate(0px, -16px)",
              }}
              href="#editDeleteClueModal"
              onClick={() => handleLoadClueClick(clueObj)}
              data-toggle="modal"
            ></i>
          </Tooltip>
        ) : null}
      </div>
    </button>
  );
};
